<template>
  <div>
    <div v-if="isMobile" class="header mobileHeader">
      <div class="avatarFrame">
        <div class="avatarMobile" :style="{ 'background-image': ImageUrl }"
          @click="$router.push('/change-picture-request')"></div>
      </div>
      <div class="nameMobile">
        <template v-if="userActive">
          <div style="font-size: 13px">{{ fullName }}</div>
          <div style="font-size: 12px">
            {{ "کد طلبگی: " + userInfo.Num_System }}
          </div>
          <div style="font-size: 11px">{{ "مدرسه " + userInfo.School }}</div>
        </template>
        <template v-else>
          <div style="font-size: 13px">
            {{ fullName }}
            <br />
          </div>
        </template>
      </div>
      <v-btn class="login-button" color="red white--text" @click="handleLogin" rounded>خروج
        <v-icon right> mdi-power </v-icon>
      </v-btn>
    </div>
    <div class="menus">
      <v-row align="center" style="margin: 0 !important" v-if="isMobile">
        <v-col align="center" v-for="(item, index) in menuDetails[selectedMenu]" :key="index" cols="4" sm="3" lg="2"
          class="menuCol">
          <v-btn class="btn-menus" @click="goToRoute(item.route)">
            <div>
              <font-awesome-icon :icon="item.icon" class="menuIcon" size="2x" :color="item.color" />
            </div>
            <span class="menuTitle" :style="[{ color: '#5c5c5c' }]">{{
              item.title
            }}</span>
            <app-notification v-if="item.route == '/messages'" />
          </v-btn>
        </v-col>
      </v-row>
      <template v-else>
        <div v-for="menuIndex in menuDetails.length" :key="menuIndex">
          <template v-if="menuDetails[menuIndex - 1].length > 0">
            <div class="trapezoid">
              <span>
                {{ menuHeaders[menuIndex - 1].title }}
              </span>
            </div>
            <v-row align="center" class="parentMenu">
              <v-col align="center" v-for="(item, index) in menuDetails[menuIndex - 1]" :key="index" cols="4" sm="3"
                lg="2" class="menuCol">
                <v-btn class="btn-menus" @click="goToRoute(item.route)">
                  <div>
                    <font-awesome-icon :icon="item.icon" class="menuIcon" size="2x" :color="item.color" />
                  </div>
                  <span class="menuTitle" :style="[{ color: '#5c5c5c' }]">{{
                    item.title
                  }}</span>
                  <app-notification v-if="item.route == '/messages'" />
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </div>
      </template>
    </div>
    <v-btn-toggle v-if="isMobile" v-model="selectedMenu" background-color="white" color="purple" style="height: 64px"
      @change="onChangeTab" mandatory>
      <v-btn style="height: 64px" v-for="(item, key) in menuHeaders" :key="key" :value="key"
        :style="[userInfo.Active ? { width: '33.33%' } : { width: '50%' }]">
        {{ item.title }}
        <font-awesome-icon :icon="item.icon" class="tabIcon" />
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { logout } from "@/utils/auth";
import UserInfo from "./UserInfo";
import Notification from "@/components/Notification";

export default {
  components: {
    userInfo: UserInfo,
    appNotification: Notification,
  },
  data() {
    return {
      selectedMenu: 0,
    };
  },
  computed: {
    fullName() {
      return this.$store.getters.FullName;
    },

    userInfo() {
      return this.$store.getters.userInfo;
    },

    ImageUrl() {
      if (this.$store.getters.ImageUrl != "") {
        return "url(" + this.$store.getters.ImageUrl + ")";
      } else return "../assets/avatar.jpg";
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },
    userActive() {
      return this.$store.getters.userInfo.Active;
    },

    menuOptions() {
      return this.$store.getters.menuOptions;
    },
    menuHeaders() {
      return this.menuOptions.filter((single) => {
        return (
          single.route == undefined &&
          (!single.needActive || this.userInfo.Active) &&
          (!single.needNoor || this.userInfo.HasNoor)
        );
      });
    },
    menuDetails() {
      var result = [];
      let root = [];
      for (let i = 1; i < this.menuOptions.length; i++) {
        const item = this.menuOptions[i];
        if (
          (!item.needActive || this.userInfo.Active) &&
          (!item.needNoor || this.userInfo.HasNoor)
        ) {
          if (item.route == undefined) {
            result.push(root);
            root = [];
          } else if (
            item.route !== "/index" &&
            item.title.toLowerCase().includes(this.searchMenu)
          ) {
            root.push(item);
          }
        }
      }
      result.push(root);
      return result;
    },
    searchMenu() {
      return this.$store.getters.searchMenu;
    },
  },
  created() {
    this.selectedMenu = this.$store.getters.selectedMenu;
  },
  methods: {
    handleLogin() {
      logout();
    },
    goToRoute(route) {
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
    onChangeTab() {
      this.$store.commit("SET_SELECTED_MENU", this.selectedMenu);
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped>
.avatarMobile {
  width: 70px;
  height: 70px;
  border-radius: 35px;
  background-size: cover;
  margin: auto;
  top: 4px;
  position: relative;
  background-position: 50%;
  cursor: pointer;
}

.avatarFrame {
  width: 80px;
  height: 80px;
  border-radius: 340px;
  margin: auto;
  top: 40px;
  position: relative;
  border: 2px dotted rgba(255, 255, 255, 0.6);
}

.header {
  top: 0;
  position: fixed;
  width: 100%;
  z-index: 2;
  padding-bottom: 5px;
  height: 225px;
  text-align: center;
}

.nameMobile {
  color: white;

  font-size: 1em;
  top: 45px;
  position: relative;
}

.login-button {
  position: fixed;
  top: 30px;
  left: 5px;
  border-radius: 4px;
  font-size: 10px;
  width: 48px !important;
  min-width: unset !important;

  height: 24px !important;
  padding: 0 8px !important;
}

.v-btn-toggle {
  width: 100%;
  position: fixed;
  bottom: 0;
}

.v-btn-toggle .v-btn {
  margin: 0 !important;
}

.menus {
  position: relative;

  padding-bottom: 70px;
  min-height: calc(100vh - 60px);
}

@media only screen and (max-width: 991px) {
  .menus {
    top: 165px;
    min-height: calc(100vh - 250px);
  }
}

@media only screen and (min-width: 992px) {
  .btn-menus {
    box-shadow: unset !important;
    border: unset;
    background-color: white !important;
  }
}

.tabIcon {
  margin-right: 10px;
}

.mobileHeader {
  background: url("../../assets/pattern.jpg") repeat-x;
}

.v-icon {
  margin: 0 !important;
  font-size: 16px;
}

.v-item--active {
  background: rgb(33, 118, 208) !important;
  background: linear-gradient(180deg,
      rgba(33, 118, 208, 1) 0%,
      rgba(33, 118, 208, 1) 35%,
      rgba(12, 50, 91, 1) 100%) !important;
  color: white !important;
}

.v-btn-toggle>.v-btn {
  border-radius: 0 !important;
}

.parentMenu {
  border: 1px solid orange;
  padding: 10px;
  border-radius: 15px 0 15px 15px;
  background-color: white;
  margin: 0 0 15px !important;
}

.trapezoid {
  height: 0;
  width: 170px;
  margin-right: 0px;
  border-radius: 15px 15px 0 0;
  height: 40px;
  background-color: orange;
  text-align: center;
}

.trapezoid>span {
  font-size: 16px;
  color: white;
  font-weight: bold;
  top: 7px;
  position: relative;

  /*right: 16px;*/
}
</style>
